import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import SEO from '../../components/base/SEO';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      type: 'image',
      image: 'https://static.readdy.ai/image/260cb4a7e92398667a2a2f5c835f3622/4e01184b0f8be21436adad1080dccc6d.png',
      title: 'Premium Chimney Systems',
      subtitle: ''
    },
    {
      type: 'image',
      image: 'https://static.readdy.ai/image/260cb4a7e92398667a2a2f5c835f3622/8872ca9155e738c7f6a390745ee2e703.jpeg',
      title: '',
      subtitle: ''
    },
    {
      type: 'image',
      image: 'https://public.readdy.ai/ai/img_res/edited_18cfd7d1aceddf60612d36de551f79d5_27363fa9.jpg',
      title: '',
      subtitle: ''
    },
    {
      type: 'image',
      image: 'https://static.readdy.ai/image/260cb4a7e92398667a2a2f5c835f3622/2fafc393e6ab329370231c792f654a22.png',
      title: '',
      subtitle: ''
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };
  
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': `${siteUrl}/#organization`,
        name: 'Proform Chimney Systems',
        url: siteUrl,
        logo: {
          '@type': 'ImageObject',
          url: 'https://proformbaca.com/wp-content/uploads/2024/02/logoproform1.png'
        },
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+90-543-457-61-96',
          contactType: 'Customer Service',
          areaServed: 'TR',
          availableLanguage: ['en', 'tr']
        },
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Akçaburgaz Mah. 3028 Sk. No:1 İç Kapı No:27',
          addressLocality: 'Esenyurt',
          addressRegion: 'Istanbul',
          addressCountry: 'TR'
        },
        sameAs: [
          'https://www.linkedin.com/company/proform-chimney-system/',
          'https://www.instagram.com/proformbaca/'
        ]
      },
      {
        '@type': 'WebSite',
        '@id': `${siteUrl}/#website`,
        url: siteUrl,
        name: 'Proform Chimney Systems',
        description: 'Proform Chimney Systems in Turkey',
        publisher: {
          '@id': `${siteUrl}/#organization`
        }
      },
      {
        '@type': 'WebPage',
        '@id': `${siteUrl}/#webpage`,
        url: siteUrl,
        name: 'Proform Chimney Systems in Turkey',
        isPartOf: {
          '@id': `${siteUrl}/#website`
        },
        about: {
          '@id': `${siteUrl}/#organization`
        },
        description: 'Proform Chimney Systems is an innovative and reliable chimney manufacturing company in Turkey. We provide the highest quality chimney systems for residential and commercial use including central heating, hood systems, and factory chimneys.'
      }
    ]
  };

  return (
    <>
      <SEO
        title="Proform Chimney Systems in Turkey"
        description="Proform Chimney Systems is an innovative and reliable chimney manufacturing company in Turkey. We provide the highest quality chimney systems for residential and commercial use including central heating, hood systems, and factory chimneys."
        keywords="chimney systems, Turkey chimney, residential chimney, commercial chimney, factory chimney, pellet chimney, hood chimney, central heating"
        canonical={siteUrl}
        schema={schema}
      />
      <div className="min-h-screen bg-white">
        {/* Hero Section with Slider */}
        <section className="relative h-screen flex items-center justify-center overflow-hidden bg-white">
          {/* Slider Slides */}
          <div className="absolute inset-0 z-0">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`absolute inset-0 transition-opacity duration-1000 ${
                  index === currentSlide ? 'opacity-100' : 'opacity-0'
                }`}
              >
                {slide.type === 'text' ? (
                  <div className="w-full h-full bg-white flex items-center justify-center">
                  </div>
                ) : (
                  <img
                    src={slide.image}
                    alt={slide.title}
                    className="w-full h-full object-cover"
                  />
                )}
              </div>
            ))}
          </div>

          {/* Slide Content */}
          <div className="relative z-10 w-full h-full flex items-center justify-center">
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-6 top-1/2 -translate-y-1/2 z-20 w-12 h-12 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer group border border-white/30"
            aria-label="Previous slide"
          >
            <i className="ri-arrow-left-s-line text-white text-2xl group-hover:scale-110 transition-transform" style={{ color: currentSlide === 1 ? '#000' : '#fff' }}></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-6 top-1/2 -translate-y-1/2 z-20 w-12 h-12 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer group border border-white/30"
            aria-label="Next slide"
          >
            <i className="ri-arrow-right-s-line text-white text-2xl group-hover:scale-110 transition-transform" style={{ color: currentSlide === 1 ? '#000' : '#fff' }}></i>
          </button>

          {/* Slider Indicators */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 flex gap-3">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`h-3 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentSlide
                    ? 'bg-orange-500 w-10'
                    : currentSlide === 1
                    ? 'bg-gray-400/70 hover:bg-gray-600 w-3'
                    : 'bg-white/50 hover:bg-white/80 w-3'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </section>

        {/* Services Section */}
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Our Premium Services</h2>
              <div className="w-24 h-1 bg-orange-500 mx-auto mb-4"></div>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Comprehensive chimney solutions tailored to meet your residential, commercial, and industrial needs
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Service 1 */}
              <div className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 cursor-pointer">
                <div className="absolute top-4 right-4 z-10 w-14 h-14 bg-orange-500 rounded-full flex items-center justify-center shadow-lg">
                  <i className="ri-stack-line text-white text-2xl"></i>
                </div>
                <div className="relative h-72 overflow-hidden">
                  <img
                    src="https://static.readdy.ai/image/260cb4a7e92398667a2a2f5c835f3622/49ef0d2acfac0c7c126654f46f4774af.jpeg"
                    alt="Double Wall Chimney Systems"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-orange-500 transition-colors duration-300">
                    Double Wall Chimney Systems
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-6">
                    High-performance double wall chimney systems designed for maximum insulation and safety. Perfect for residential and commercial applications requiring superior heat retention and protection.
                  </p>
                  <Link 
                    to="/services/double-wall" 
                    className="inline-flex items-center text-[#1e3a8a] font-semibold hover:text-orange-500 transition-colors duration-300 cursor-pointer whitespace-nowrap group/link"
                  >
                    Learn More
                    <i className="ri-arrow-right-line ml-2 group-hover/link:translate-x-2 transition-transform duration-300"></i>
                  </Link>
                </div>
              </div>

              {/* Service 2 */}
              <div className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 cursor-pointer">
                <div className="absolute top-4 right-4 z-10 w-14 h-14 bg-orange-500 rounded-full flex items-center justify-center shadow-lg">
                  <i className="ri-fire-line text-white text-2xl"></i>
                </div>
                <div className="relative h-72 overflow-hidden">
                  <img
                    src="https://static.readdy.ai/image/260cb4a7e92398667a2a2f5c835f3622/c461eda7b1ab3b5df438ceb720f5c69d.jpeg"
                    alt="Single Wall Chimney Systems"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-orange-500 transition-colors duration-300">
                    Single Wall Chimney Systems
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-6">
                    Cost-effective single wall chimney solutions ideal for various heating applications. Reliable performance with straightforward installation for both residential and light commercial use.
                  </p>
                  <Link 
                    to="/services/single-wall" 
                    className="inline-flex items-center text-[#1e3a8a] font-semibold hover:text-orange-500 transition-colors duration-300 cursor-pointer whitespace-nowrap group/link"
                  >
                    Learn More
                    <i className="ri-arrow-right-line ml-2 group-hover/link:translate-x-2 transition-transform duration-300"></i>
                  </Link>
                </div>
              </div>

              {/* Service 3 */}
              <div className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 cursor-pointer">
                <div className="absolute top-4 right-4 z-10 w-14 h-14 bg-orange-500 rounded-full flex items-center justify-center shadow-lg">
                  <i className="ri-shield-check-line text-white text-2xl"></i>
                </div>
                <div className="relative h-72 overflow-hidden">
                  <img
                    src="https://static.readdy.ai/image/260cb4a7e92398667a2a2f5c835f3622/7c7c16c4859bfb1f98160792a2b2369e.jpeg"
                    alt="Hermetic Chimney Systems"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-orange-500 transition-colors duration-300">
                    Hermetic Chimney Systems
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-6">
                    Advanced hermetic chimney systems providing complete air-tight sealing for maximum efficiency. Ideal for modern energy-efficient buildings and condensing boiler applications.
                  </p>
                  <Link 
                    to="/services/hermetic" 
                    className="inline-flex items-center text-[#1e3a8a] font-semibold hover:text-orange-500 transition-colors duration-300 cursor-pointer whitespace-nowrap group/link"
                  >
                    Learn More
                    <i className="ri-arrow-right-line ml-2 group-hover/link:translate-x-2 transition-transform duration-300"></i>
                  </Link>
                </div>
              </div>
            </div>

            <div className="text-center mt-12">
              <Link
                to="/services"
                className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
              >
                View All Services
              </Link>
            </div>
          </div>
        </section>

        {/* Why Choose Us Section */}
        <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Why Choose Proform?</h2>
              <div className="w-24 h-1 bg-orange-500 mx-auto mb-4"></div>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Industry-leading expertise and commitment to excellence in every project
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center group cursor-pointer">
                <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-award-line text-white text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Premium Quality</h3>
                <p className="text-gray-600 leading-relaxed">
                  ISO certified manufacturing with the highest quality standards and materials
                </p>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center group cursor-pointer">
                <div className="w-20 h-20 bg-gradient-to-br from-[#1e3a8a] to-[#1e40af] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-team-line text-white text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Expert Team</h3>
                <p className="text-gray-600 leading-relaxed">
                  Experienced professionals dedicated to delivering exceptional results
                </p>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center group cursor-pointer">
                <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-leaf-line text-white text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Eco-Friendly</h3>
                <p className="text-gray-600 leading-relaxed">
                  Sustainable solutions that reduce environmental impact and energy costs
                </p>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center group cursor-pointer">
                <div className="w-20 h-20 bg-gradient-to-br from-[#1e3a8a] to-[#1e40af] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-customer-service-2-line text-white text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">24/7 Support</h3>
                <p className="text-gray-600 leading-relaxed">
                  Comprehensive after-sales service and technical support whenever you need
                </p>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center group cursor-pointer">
                <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-shield-check-line text-white text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Safety First</h3>
                <p className="text-gray-600 leading-relaxed">
                  Rigorous safety standards and testing for complete peace of mind
                </p>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center group cursor-pointer">
                <div className="w-20 h-20 bg-gradient-to-br from-[#1e3a8a] to-[#1e40af] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-time-line text-white text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Fast Delivery</h3>
                <p className="text-gray-600 leading-relaxed">
                  Efficient production and logistics ensuring timely project completion
                </p>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center group cursor-pointer">
                <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-price-tag-3-line text-white text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Competitive Pricing</h3>
                <p className="text-gray-600 leading-relaxed">
                  Best value for money without compromising on quality or service
                </p>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center group cursor-pointer">
                <div className="w-20 h-20 bg-gradient-to-br from-[#1e3a8a] to-[#1e40af] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-global-line text-white text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Global Reach</h3>
                <p className="text-gray-600 leading-relaxed">
                  International presence with proven track record across multiple countries
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Exhibitions Section */}
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Exhibitions & Events</h2>
              <div className="w-24 h-1 bg-orange-500 mx-auto mb-4"></div>
              <p className="text-xl text-gray-600">
                Showcasing innovation at major industry exhibitions worldwide
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
              <div className="group relative bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer">
                <div className="relative h-80 overflow-hidden">
                  <img
                    src="https://static.readdy.ai/image/260cb4a7e92398667a2a2f5c835f3622/83549f9c862859ca7232b94120293fce.jpeg"
                    alt="International Exhibition"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-2xl font-bold mb-2">International Trade Fair</h3>
                    <p className="text-white/90">Presenting our latest innovations to global partners</p>
                  </div>
                </div>
              </div>

              <div className="group relative bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer">
                <div className="relative h-80 overflow-hidden">
                  <img
                    src="https://static.readdy.ai/image/260cb4a7e92398667a2a2f5c835f3622/438004ec34177dcdd6f3334854c87588.jpeg"
                    alt="MCE 2024"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-2xl font-bold mb-2">MCE 2024 Exhibition</h3>
                    <p className="text-white/90">Leading the industry with cutting-edge technology</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 bg-gradient-to-br from-[#1e3a8a] via-[#1e40af] to-[#2563eb] relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          </div>
          <div className="max-w-5xl mx-auto px-6 text-center relative z-10">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Ready to Get Started?
            </h2>
            <p className="text-xl text-white/90 mb-10 leading-relaxed max-w-3xl mx-auto">
              Contact us today for a free consultation and discover how our premium chimney systems can meet your specific needs. Our expert team is ready to help you find the perfect solution.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link
                to="/contact"
                className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl"
              >
                Get a Free Quote
              </Link>
              <a
                href="https://wa.me/905434576196"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-green-500 hover:bg-green-600 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl"
              >
                <i className="ri-whatsapp-fill text-2xl mr-2"></i>
                WhatsApp Us
              </a>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}